var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var getUpdatedFullMenu = function (_a) {
    var loadedItems = _a.loadedItems, fullMenu = _a.fullMenu;
    return fullMenu.map(function (fullMenuItem) {
        var _a, _b, _c;
        var loadedItem = loadedItems.find(function (loadedItem) { return loadedItem.name === fullMenuItem.name; });
        var isCompleteConfig = ((_a = fullMenuItem.config) === null || _a === void 0 ? void 0 : _a.routeName) && ((_b = fullMenuItem.config) === null || _b === void 0 ? void 0 : _b.routePath);
        if (loadedItem &&
            loadedItem.routeName &&
            loadedItem.path &&
            !isCompleteConfig) {
            return __assign(__assign({}, fullMenuItem), { config: fullMenuItem.config
                    ? __assign(__assign(__assign({}, fullMenuItem.config), loadedItem.config), { routeName: loadedItem.routeName, routePath: loadedItem.path }) : __assign(__assign({}, loadedItem.config), { routeName: loadedItem.routeName, routePath: loadedItem.path, loadRef: __assign({ JS: 'not existed during first load' }, (_c = loadedItem === null || loadedItem === void 0 ? void 0 : loadedItem.config) === null || _c === void 0 ? void 0 : _c.loadRef) }) });
        }
        return fullMenuItem;
    });
};
